// Notifications page.
export const notifications: Record<string, string> = {
  'Notifications': 'Obaveštenja',
  'Go back': 'Nazad',
  'Refresh notifications': 'Osveži obaveštenja',
  'interaction': 'interakcija',
  'interactions': 'interakcija',
  'Mark all read': 'Označi sve kao pročitano',
  // Filter tabs
  'All': 'Sve',
  'Likes': 'Lajkovi',
  'Comments': 'Komentari',
  'Follows': 'Praćenja',
  'Reactions': 'Reakcije',
  // States
  'Failed to load notifications': 'Učitavanje obaveštenja nije uspelo',
  'No notifications yet': 'Još nema obaveštenja',
  'No notifications in this category': 'Nema obaveštenja u ovoj kategoriji',
  "When someone likes, comments on your ideas, or follows you, you'll see it here.":
    'Kada neko lajkuje ili komentariše tvoje ideje, ili te zaprati, videćeš to ovde.',
  'You have no notifications of this type at the moment.': 'Trenutno nemaš obaveštenja ovog tipa.',
  // Relative time
  'just now': 'upravo sada',
  'm ago': ' min',
  'h ago': ' h',
  'd ago': ' d',
  // Welcome notification
  'Welcome to ShowMeTrade 🎉': 'Dobro došao na ShowMeTrade 🎉',
  'Your': 'Tvoj',
  '$10,000 simulated trading account': 'simulirani trejding nalog od $10.000',
  'was opened automatically when you registered. Every signal you publish is executed on that account and counts toward your equity and your public track record — post only signals you truly stand behind.':
    'je automatski otvoren kada si se registrovao. Svaki signal koji objaviš izvršava se na tom nalogu i računa se u tvoj kapital i javnu istoriju rezultata — objavljuj samo signale iza kojih zaista stojiš.',
  "When you're ready, you can also open your own": 'Kada budeš spreman, možeš otvoriti i sopstveni',
  'paid channel': 'plaćeni kanal',
  'and monetize your signals.': 'i monetizovati svoje signale.',
  'Create your channel →': 'Napravi svoj kanal →',
  // Trade outcome notifications
  'trade': 'trejd',
  'hit Take Profit ✅': 'je pogodio Take Profit ✅',
  'hit Stop Loss ❌': 'je pogodio Stop Loss ❌',
  // Trade Battle outcomes
  'You won the Trade Battle on': 'Dobio si trejd bitku na',
  'You lost the Trade Battle on': 'Izgubio si trejd bitku na',
  'against': 'protiv',
  'another trader': 'drugog trejdera',
  // Channel signal
  'your channel': 'tvom kanalu',
  'New signal in': 'Novi signal u',
  // Signal SL/TP updated (public ledger — followers + channel subscribers)
  'updated SL/TP on': 'je izmenio SL/TP na',
  // Social notifications
  'liked your trade': 'lajkuje tvoj trejd',
  'commented on': 'komentariše',
  'replied to your comment': 'odgovara na tvoj komentar',
  'on': 'na',
  'started following you': 'te sada prati',
  'reacted': 'reaguje',
  '— new comment on your topic': '— novi komentar na tvoju temu',
  '— new reply to your comment in': '— novi odgovor na tvoj komentar u temi',
  'Your username was changed': 'Tvoje korisničko ime je promenjeno',
  'Your previous username was created from your email address, so we changed it to protect your privacy. You can pick a different one in settings.': 'Prethodno korisničko ime je bilo napravljeno od tvoje email adrese, pa smo ga promenili radi zaštite privatnosti. Drugo ime možeš izabrati u podešavanjima.',
  'Open settings →': 'Otvori podešavanja →',
  'Share your win →': 'Podeli pobedu →',
};
